export default __webpack_public_path__ + "static/media/dark-right-chevron.110b9680.svg";